export default "__VITE_ASSET__CAelvIK$__$_?url__"